/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import { Modal, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import { HiPlus } from "react-icons/hi";
import ReactPaginate from "react-paginate";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { HomeIcon } from "../../../components/Application/ApplicationIcon";
import { Message } from "../../../components/message";
import NotFoundTable from "../../../components/notFound/NotFoundTable";
import {
  deleteCategoryData,
  getCategoriesFees,
  getSubCategoryListDataSort,
  subCategoryFeesEnableDisable
} from "../../../services/api/admin";
import {
  customStylesAcc,
  formatDateWithSlash,
  selectTheme,
} from "../../../Utils/common";
import { Imageurl } from "../../../Utils/Utils";
import "../Admin.css";
import AdminDashboard from "../AdminDashboard/AdminDashboard";
import { DeleteIcon, EditIcon } from "../AdminIcon";
import {
  checkPermission,
  permissionsConfig,
} from "../AdminPermission/PermissionChecker";
import TotalRecords from "../../../components/notFound/TotalRecords";

const CategoryFees = () => {
  const navigate = useNavigate();
  const [searchCategory, setSearchCategory] = useState();
  const [searchData, setSearchData] = useState("");
  const [sortBy, setSortBy] = useState("created_at");
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [tableDataLoaded, setTableDataLoaded] = useState(false);
  const [apiMessage, setApiMessage] = useState({ type: "", message: "" });
  const [deleteData, setDeleteData] = useState();
  const [orderBy, setOrderBy] = useState("desc");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const { state } = useLocation();
  const [searchTerm, setSearchTerm] = useState();
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    if (state && state.message) {
      setApiMessage({ type: "success", message: state.message });
      window.history.replaceState({}, document.title);
    }
  }, [state]);

  const grantPermissionForAddCategoryFees = checkPermission(
    permissionsConfig.addCategoryFees.role,
    permissionsConfig.addCategoryFees.action,
    permissionsConfig.addCategoryFees.type
  );
  const grantPermissionForEditCategoryFees = checkPermission(
    permissionsConfig.editCategoryFees.role,
    permissionsConfig.editCategoryFees.action,
    permissionsConfig.editCategoryFees.type
  );
  const grantPermissionForDeleteCategoryFees = checkPermission(
    permissionsConfig.deleteCategoryFees.role,
    permissionsConfig.deleteCategoryFees.action,
    permissionsConfig.deleteCategoryFees.type
  );

  //category list

  const resetFilter = () => {
    setSearchCategory("");
    getSubCategoryData("", sortBy, 1, orderBy, searchData);
  };

  // Fees list
  const getSubCategoryData = async (
    searchedCategory,
    sortBy,
    pageNo,
    orderBy,
    searchBy
  ) => {
    try {
      setSearchData(searchBy);
      setOrderBy(orderBy);
      setSortBy(sortBy);
      const subCategoryList = await getCategoriesFees(sortBy, orderBy, searchBy ?? '', pageNo);
      if (subCategoryList?.status == 200) {
        setTotalPages(
          Math.ceil(
            subCategoryList?.data?.total / subCategoryList?.data?.per_page
          )
        );
        setCurrentPage(pageNo > 0 ? pageNo - 1 : pageNo);
        const data = subCategoryList?.data?.data;
        setSubCategoryList(data);
        setTotalRecords(subCategoryList?.data?.total ? subCategoryList?.data?.total : 0);
      } else {
        setSubCategoryList([]);
        setTotalRecords(0);
        setApiMessage({ type: "error", message: subCategoryList?.message });
      }
      setTableDataLoaded(true);
    } catch (err) {
      setTableDataLoaded(true);
      setTotalRecords(0);
      //console.log("Error on subCategorylist: ", err);
    }
  };

  const handlePageChange = (selectedPage) => {
    getSubCategoryData(
      searchCategory,
      sortBy,
      selectedPage.selected + 1,
      orderBy,
      searchData
    ); // Increment by 1 if the API starts page numbers from 1
  };

  //get font families
  useEffect(() => {
    getSubCategoryData("", "created_at", 1, "desc", "");
  }, []);

  // delete sub-Category
  const deleteSubCategory = async (item) => {
    try {
      const formData = new FormData();
      formData.append("parent_category_id", item?.parent_category_id);
      formData.append("category_id", item?.id);
      await deleteCategoryData(formData);
      getSubCategoryData(
        searchCategory,
        sortBy,
        currentPage,
        orderBy,
        searchData
      );
      setDeleteData("");
    } catch (error) {
      //console.error(error);
    }
  };

  const handleEnableDisable = async (e, item) => {
    try {
      const formData = new FormData();
      formData.append("fees_id", item?.id);
      formData.append("status", e?.value);
      const data = await subCategoryFeesEnableDisable(formData); // api same for cat and sub cat
      if (data?.status == 200) {
        getSubCategoryData(searchCategory, sortBy, currentPage + 1, orderBy, searchData);
      } else {
        setApiMessage({ type: "error", message: data?.message });
      }
    } catch (error) {
      //console.error(error);
      setApiMessage({ type: "error", message: error?.message });
    }
  };

  return (
    <AdminDashboard>
      <div className="aod-outer">
        {apiMessage && (
          <Message
            apiMessage={apiMessage}
            setApiMessage={setApiMessage}
          ></Message>
        )}
        <div className="ap-breadcrumb pt-2 pb-2 mb-2 adm-breadcrumb">
          <div>
            <HomeIcon />
            <b onClick={() => navigate("/admin/")}>Home /</b>{" "}
            <span>Fees</span>
          </div>
          {grantPermissionForAddCategoryFees ? (
            <button
              className="adm-tab-btn"
              onClick={() => navigate("/admin/category/fees/add")}
            >
              <span>
                <HiPlus />
              </span>{" "}
              Add
            </button>
          ) : (
            ""
          )}
        </div>
        <div className="aod-inner pt-0">
          <div className="aod-bottom">
            <div className="adm-tabs-outer d-flex justify-content-between">
              <h4 className="mb-0">Fees Details</h4>{" "}
              <div className="position-relative  w-md-50 w-25">
                {searchTerm && ( // Show the clear button only when there's text
                  <button
                    className="btn btn-clear position-absolute"
                    onClick={(e) => {
                      setSearchTerm(""); // Clear the input value
                      getSubCategoryData(searchCategory, sortBy, 1, orderBy, e.target.value); // Fetch data with empty search term
                    }}
                    style={{
                      top: "50%",
                      right: "10px",
                      transform: "translateY(-50%)",
                      border: "none",
                      background: "transparent",
                      fontSize: "1rem",
                      cursor: "pointer",
                    }}
                  >
                    &times; {/* This is the "X" icon */}
                  </button>
                )}
              </div>
            </div>
            <div className="aod-head"></div>
            <div className="row py-4">
              <div className="col-md-4 aod-resp-tab">
                <div className="suf-input-box aod-form-input mb-2">
                </div>
              </div>
              <div className="col-md-6">
              </div>
              <TotalRecords totalRecords={totalRecords}></TotalRecords>
            </div>
            <div className="ad-reg-table">
              <Table size="sm" className="ad-cat-table">
                <thead>
                  <tr>
                    <th className="ad-sno">S. No</th>
                    <th className="ad-long">Sub Category</th>
                    <th
                      className="ad-long cursor-pointer"
                      onClick={(e) =>
                        getSubCategoryData(
                          searchCategory,
                          "fees",
                          currentPage + 1,
                          orderBy == "asc" ? "desc" : "asc",
                          searchData
                        )
                      }
                    >
                      Fees
                      <span><i className="fa-solid fa-sort"></i></span>
                    </th>
                    <th
                      className="ad-long cursor-pointer"
                      onClick={(e) =>
                        getSubCategoryData(
                          searchCategory,
                          "timeline",
                          currentPage + 1,
                          orderBy == "asc" ? "desc" : "asc",
                          searchData
                        )
                      }
                    >
                      Timeline
                      <span><i className="fa-solid fa-sort"></i></span>
                    </th>
                    <th
                      className="ad-long cursor-pointer"
                      onClick={(e) =>
                        getSubCategoryData(
                          searchCategory,
                          "certificate_tenure",
                          currentPage + 1,
                          orderBy == "asc" ? "desc" : "asc",
                          searchData
                        )
                      }
                    >
                      Certificate Tenure
                      <span><i className="fa-solid fa-sort"></i></span>
                    </th>
                    
                      <th
                      className="ad-long cursor-pointer"
                      onClick={(e) =>
                        getSubCategoryData(
                          searchCategory,
                          "created_at",
                          currentPage + 1,
                          orderBy == "asc" ? "desc" : "asc",
                          searchData
                        )
                      }
                    >
                      Created At
                      <span><i className="fa-solid fa-sort"></i></span>
                    </th>
                    
                    {grantPermissionForEditCategoryFees ? (
                      <>
                        <th className="ad-long">Status</th>
                      </>
                    ) : (
                      ""
                    )}
                    {grantPermissionForEditCategoryFees || grantPermissionForDeleteCategoryFees ? (
                      <>
                        <th className="ad-long">Actions</th>
                      </>
                    ) : (
                      ""
                    )}
                  </tr>
                </thead>
                <tbody>
                  {subCategoryList?.length > 0 ? (
                    subCategoryList?.map((item, index) => (
                      <tr
                        key={index}
                        className={index % 2 != 0 ? "adm-even" : ""}
                      >
                        <td>{currentPage * 10 + (index + 1)}</td>
                        <td>
                          {item?.category.category_name ? item?.category.category_name : "--"}
                        </td>
                        <td>
                          {item?.fees ? item.fees : ""}
                        </td>
                        <td>
                          {item?.timeline ? item?.timeline : "--"}
                        </td>
                        <td>
                          {item?.certificate_tenure
                            ? item?.certificate_tenure
                            : "--"}
                        </td>
                        <td>
                          {item?.created_at
                            ? formatDateWithSlash(item?.created_at)
                            : "--"}
                        </td>
                        {grantPermissionForEditCategoryFees ? 
                            <td>
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={item?.status == 1}
                                  onChange={(e) =>
                                    handleEnableDisable(
                                      e.target.checked
                                        ? { value: "1" }
                                        : { value: "0" },
                                      item
                                    )
                                  }
                                />
                                <span className="slider"></span>
                              </label>
                            </td> : <></>}

                            <td>
                              <div className="action-btn d-flex">
                              {grantPermissionForEditCategoryFees ?
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id={`edit-tooltip-${item.id}`}>
                                        Edit
                                      </Tooltip>
                                    }
                                  >
                                    <span
                                      className="ad-cat-edit"
                                      onClick={() => {
                                        navigate("/admin/category/fees/update", {
                                          state: item,
                                        });
                                      }}
                                    >
                                      <EditIcon />
                                    </span>
                                  </OverlayTrigger> : <></>}
                                {grantPermissionForDeleteCategoryFees ?
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id={`delete-tooltip-${item.id}`}>
                                        Delete
                                      </Tooltip>
                                    }
                                  >
                                    <span
                                      className="ad-cat-delete"
                                      onClick={() => setDeleteData(item)}
                                    >
                                      <DeleteIcon />
                                    </span>
                                  </OverlayTrigger> : <></>}
                              </div>
                            </td>
                      </tr>
                    ))
                  ) : tableDataLoaded ? (
                    <NotFoundTable colSpan="9"></NotFoundTable>
                  ) : (
                    <></>
                  )}
                </tbody>
              </Table>
              {totalPages > 1 && subCategoryList?.length > 0 &&
                <div className="d-flex w-100 justify-content-end">
                  <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      pageCount={totalPages} // Total number of pages from API
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={1}
                      onPageChange={handlePageChange} // Method to handle page click
                      forcePage={currentPage}
                      containerClassName={"pagination justify-content-center"} // Custom CSS classes
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={`page-item${!subCategoryList?.length > 0 ? ' disabled' : ''}`}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}
                  />
              </div>

              }
            </div>
          </div>
        </div>
      </div>
      <Modal show={deleteData?.id} onHide={() => setDeleteData("")}>
        <Modal.Header closeButton>
          <Modal.Title>
            Do you really want to delete sub this Category ?
          </Modal.Title>
        </Modal.Header>
        {/* <Modal.Body></Modal.Body> */}
        <Modal.Footer>
          <div className="suf-btn p-2 d-flex flex-row">
            <button
              className="mx-2"
              onClick={() => {
                deleteSubCategory(deleteData);
              }}
            >
              Yes
            </button>
            <button
              className="suf-can-butt no-btn mx-2"
              onClick={() => setDeleteData("")}
            >
              No
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </AdminDashboard>
  );
};

export default CategoryFees;
